module.exports = __webpack_public_path__ + "static/cc-3-42737332c2d75b74cb4a70f053a32ed9.jpg";